import { styled } from '@styledComponents';
import { TOP_BANNER_HEIGHT } from './Layout.constants';
import { ReactComponent as JoyHeartIconSvg } from '@images/joy-heart.svg';
import { themeColor, themeSpace, themeMediaQuery, themeVariant } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';

const SLIDER_HEIGHT = 23;

export const StyledNavText = styled(Flex)`
  color: ${themeColor('white')};
  white-space: nowrap;
  ${themeVariant('dek15')}
  line-height: ${SLIDER_HEIGHT}px;
`;

export const StyledCTAText = styled(Flex)`
  color: ${themeColor('white')};
  ${themeVariant('dek15')}
  line-height: ${SLIDER_HEIGHT}px;

  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledArrowIcon = styled(JoyHeartIconSvg)`
  transform: rotate(-90deg);
  margin-left: ${themeSpace(1)};
`;

export const MobileStyledArrowIcon = styled(StyledArrowIcon)`
  vertical-align: middle;

  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StyledLabelCTA = styled.span``;

export const StyledBannerContainer = styled.a<{ opacity?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${TOP_BANNER_HEIGHT}px;
  background: ${themeColor('actionPurple2')};
  position: relative;
  top: -${TOP_BANNER_HEIGHT}px;
  animation: topbar;
  animation-delay: 0.6s;
  animation-duration: 4s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
  opacity: ${props => props.opacity};

  @keyframes topbar {
    20% {
      background: ${themeColor('actionPurple2')};
      top: 0;
    }

    75% {
      background: ${themeColor('actionPurple2')};
      top: 0;
    }

    100% {
      background: ${themeColor('black')};
      top: 0;
    }
  }

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.9;
    ${StyledArrowIcon} {
      transform: rotate(0deg);
    }
  }
`;

export const WrapperSlider = styled(Flex)`
  display: inline-block;
  height: ${SLIDER_HEIGHT}px;
  overflow: hidden;
  position: relative;
  width: 200px;
  color: white;
  ${themeVariant('dek15')};
  line-height: ${SLIDER_HEIGHT}px;
`;

export const ContentSlider = styled(Flex)`
  --height: ${SLIDER_HEIGHT}px;

  @keyframes slideup {
    0%  {top: 0}
    23%  {top: 0}
    
    25% {top: calc(var(--height) * -1)}
    48% {top: calc(var(--height) * -1)}

    50% {top: calc(var(--height) * -2)}
    73% {top: calc(var(--height) * -2)}

    75% {top: calc(var(--height) * -3)}
    98% {top: calc(var(--height) * -3)}

    100% {top: calc(var(--height) * -4)}
  }

  display: block;
  width: 100%;
	position: absolute;
  line-height: ${SLIDER_HEIGHT}px;
  font-size: 15px;  
  animation-delay: 4.6s;
	animation-name: slideup;
	animation-duration: 10s;
	animation-iteration-count: infinite;
	animation-timing-function: ease;
}
`;

export const TextHiddenOnMobile = styled.span`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
